import SelectShapeType from "@/components/BasicInfo/SelectShapeType";
import SelectDoorType from "@/components/BasicInfo/SelectDoorType";
import SelectWidth from "@/components/BasicInfo/SelectWidth";
import SelectHeight from "@/components/BasicInfo/SelectHeight";
import SelectDepth from "@/components/BasicInfo/SelectDepth";
import SelectColor from "@/components/BasicInfo/SelectColor";
import NavBar from "@/components/Navbar/NavBar";
import Breadcrumb from "@/components/Navbar/Breadcrumb";
import BottomBar from "@/components/BasicInfo/BottomBar";
import styles from "@/common/Common.module.scss";
import sizeStyles from "./index.module.scss";
import StepIcon1 from "../../assets/icons/step_1_3.svg"
import DownTipArrow from "../../assets/icons/down_tip_arrow.svg";
import BlueRightArrow from "../../assets/icons/blue_right_arr.svg"
import React, { useEffect, useRef, useState, Suspense, useCallback, MutableRefObject } from "react";
import classnames from 'clsx';
import { useConfig } from "@/reducers/searchConfReducer";
import { PaxActionType, usePaxConfig } from 'reducers/paxReducer';
import { debounce } from "lodash";
import { TopToast } from "@/components/Toast/TopToast";
import { createTemplate } from '@/utils/tool-3d';
import LoadingImg from "assets/images/loading.gif";
import { plugin3d } from "@/pax3d/global";
import TemplateTool from "@/utils/template-tool";
import { BASE_SIZE, DoorType, FrameColor, FROM_FLOW, FROM_PAGE, STORAGE_KEYS } from "@/common/CommonType";
import { useQuery } from "@/hooks";
import { pageViewGio } from "@/hooks/gio";
import { FrameColorList } from '@/constants/colors';
import { slidingDoorOutOfStock } from "@/api/configAPIs";
import { useHistory, useLocation } from "react-router-dom";
import { GIO, GioModuleVar } from "@/utils/gioUtils";
import ResetTipsModal from "@/components/ResetDrawers/IndexResetModal";

const Pax3D = React.lazy(() => import('@/pax3d/Pax3D'));


let is3DUpdating = false;
const update3DScene = debounce(async (templateData) => {
  console.log('is3DUpdating1', is3DUpdating)
  if (is3DUpdating) {
    console.log('is3DUpdating2', is3DUpdating)
    return;
  }
  is3DUpdating = true;
  const { WardrobeModel } = await import('@/pax3d/parser/WardrobeModel');
  const wardrobeModel = new WardrobeModel(templateData);
  const nodes = wardrobeModel.getNodes();
  console.log('----plugin3d', plugin3d);
  plugin3d?.asyncLoadScene(nodes).then(async () => {
    if (plugin3d) {
      const { width, height } = plugin3d.getWardrobeSize();
      const max = Math.max(width, height); // 高和宽取最大值
      const radius = (max ?? 5000) * (max === height ? 1.5 : 1.5); // 默认相机距离计算
      await plugin3d.cameraAnimationManager?.centerView(radius, -Math.PI / 3);
    }
  }).finally(() => {
    is3DUpdating = false;
    console.log('is3DUpdating3', is3DUpdating)
  });
  if (!plugin3d) is3DUpdating = false;
  console.log('is3DUpdating4', is3DUpdating)
}, 1000);

function SizeFilter() {
  const { state } = useConfig()
  const { state: appState, dispatch: appDispatch } = usePaxConfig()
  const { hasToBottom, showToBottomBtn, recommendTemplate, previousLocation } = appState

  const bodyRef = useRef<HTMLDivElement>(null);
  const [isShowToast, setIsShowToast] = useState(false);
  const timer1: any = useRef(), timer2: any = useRef()
  const reset = useQuery().get('reset');

  const defaultShowResetTips = localStorage.getItem('showResetTips') === 'true'
  const [showResetTips, setShowResetTips] = useState(defaultShowResetTips)

  const { doorType } = state; // 门型无法从template中拿，因为此页面的template都无门
  // width、height、depth、frameColor优先从template中拿，取不到则取默认值
  const templateTool = reset ? null : new TemplateTool(recommendTemplate?.wardrobeWithProduct)
  const [width, setWidth] = useState(templateTool?.wardrobeWidth || BASE_SIZE.WIDTH)
  const [height, setHeight] = useState(templateTool?.wardrobeHeight || BASE_SIZE.HEIGHT)
  const [depth, setDepth] = useState(templateTool?.wardrobeDepth || BASE_SIZE.DEPTH)
  const [frameColor, setFrameColor] = useState(templateTool?.wardrobeFrameColor as FrameColor || BASE_SIZE.FRAME_COLOR)
  const bottomBarRef: MutableRefObject<any> = useRef(null);
  const [isSliderOutOfStock, setIsSliderOutOfStock] = useState(false);
  const history = useHistory()

  const onInit = useCallback(() => {
    console.log('initRender')
    if (!appState.tokenLoaded) return;
    const redirectRoute = localStorage.getItem('redirectRoute')
    console.log('redirectRoute', redirectRoute)
    if (width > 300 || redirectRoute === 'true') return
    const scale = 10;
    console.log('-----plugin3d', plugin3d);

    // try to keep last combination
    let combination = undefined;
    if (appState.recommendTemplate?.wardrobeWithProduct) {
      combination = [];
      let total = 0;
      appState.recommendTemplate.wardrobeWithProduct.frames.forEach((frame) => {
        combination.push(frame.width);
        total += frame.width;
      });
      if (total !== width * scale) {
        combination = undefined;
      }
    }

    const templateData =
      createTemplate({
        width: width * scale,
        height: height * scale,
        depth: depth * scale,
        frameColor,
        doorType,
        combination
      });
    update3DScene(templateData);
    // 随时跟新store中的template
    appDispatch({
      type: PaxActionType.Update,
      payload: {
        recommendTemplate: Object.assign({}, appState.recommendTemplate,
          {
            templateId: "",
            wardrobeWithProduct: templateData
          })
      }
    })
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [width, height, depth, frameColor, doorType, appState.tokenLoaded]);

  // todo: tgr
  useEffect(() => {
    if (!width || !height) return
    if (!appState.tokenLoaded) return;
    slidingDoorOutOfStock<{
      isOutOfStock: boolean
    }>({
      width: Number(width) * 10,
      height: Number(height) * 10,
    }).then(res => {
      setIsSliderOutOfStock(res.isOutOfStock || false);
    })
  }, [width, height, appState.tokenLoaded])

  const [cscCustomerText, setCscCustomerText] = useState('')

  useEffect(() => {
    onInit()
    const fColor = FrameColorList.find(item => item.colorName === frameColor);
    const temp = [
      '我需要购买PAX衣柜，',
      `我的衣柜尺寸：${width > 300 ? '300以上' : width}cm宽，${height}cm高，${depth}cm深，`,
      `我选择的衣柜颜色${fColor ? fColor.displayName : ''}。`,
    ];
    setCscCustomerText(temp.join(''))
  }, [height, width, depth, frameColor, doorType, onInit]);

  //只有ABTest方案1屏沉浸式页面才有用到这个方法
  const handleScroll = debounce(() => {
    if (bodyRef.current !== null) {
      // 60的值是最后柜体颜色选择项只要露出一部分就算滑到底部了
      if (bodyRef.current.scrollTop + bodyRef.current.clientHeight >= bodyRef.current.scrollHeight - 60) {
        appDispatch({
          type: PaxActionType.Update,
          payload: {
            showToBottomBtn: false,
          }
        })
        appDispatch({
          type: PaxActionType.Update,
          payload: {
            hasToBottom: true,
          }
        })
      }
      bottomBarRef.current.setShowAll(false);
    }
  }, 200);
  // 只有ABTest方案1屏沉浸式页面才有用到这个方法：判断是否到了底部，到底部直接下一步操作，不到底部则提示且自动滚动到下面一部分
  const clickNextBtn = () => {
    if (bodyRef.current !== null) {
      // 60的值是最后柜体颜色选择项只要露出一部分就算滑到底部了
      if (bodyRef.current.scrollTop + bodyRef.current.clientHeight < bodyRef.current.scrollHeight - 60) {
        setIsShowToast(true);
        timer1.current = setTimeout(() => {
          setIsShowToast(false);
        }, 2000);
        bodyRef.current.scroll({ top: bodyRef.current.clientHeight + bodyRef.current.scrollTop, behavior: "smooth" },)
      }
    }
  }
  // 只有ABTest方案1屏沉浸式页面才会显示向上滑提示动画按钮，4S后自动消失
  useEffect(() => {
    // 因为abtest请求被改为异步，首页初始化时，abtest结果还未返回结果，延迟100ms来hack
    setTimeout(() => {
      const isOnline2offline = sessionStorage.getItem('abtestPaxOnline2offline') === 'SHOW'
      // 强制下移1px，必定触发按钮提示的隐藏
      if (isOnline2offline && bodyRef.current !== null) {
        bodyRef.current?.scrollTo(0, 1)
      }
    }, 300)
    timer2.current = setTimeout(() => {
      appDispatch({
        type: PaxActionType.Update,
        payload: {
          showToBottomBtn: false,
        }
      })
    }, 4000)
    pageViewGio(previousLocation ? previousLocation.pathname : undefined);
    return () => {
      if (timer1.current) window.clearTimeout(timer1.current)
      if (timer2.current) window.clearTimeout(timer2.current)
      is3DUpdating = false
      update3DScene.cancel()
      console.log('is3DUpdating5', is3DUpdating)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const goToLeads = () => {
    GIO('track', 'clickData', {
      module_var: GioModuleVar.customizeGuide,
      objectName_var: '定制衣柜入口leads',

    })
    history.push('/custom_landingpage?channel=PAX_AI&source=wardrobe_size')
  }

  return (
    <div className={styles.Container} style={{ padding: "0" }}>
      <div className={styles.Header}>
        <NavBar
          img={StepIcon1}
          text={'衣柜基础信息'}
          showBackIcon={false}
          noClose={false}
          cscCustomerText={cscCustomerText}
        />
        <Breadcrumb step={1}/>
      </div>
      <React.Fragment>
        <Suspense
          fallback={<div className={sizeStyles.loadSuspense}><img className={sizeStyles.Loading} src={LoadingImg}
                                                                  alt="Loading"/></div>}>
          <Pax3D onModeChange={() => {
          }} onInit={onInit}></Pax3D>
        </Suspense>
        <div className={classnames(styles.Body, sizeStyles.radiusBody)}
             ref={bodyRef} onScroll={handleScroll}>
          <div className={classnames(sizeStyles.innerRadiusBody)}>
            <SelectShapeType />
            <SelectDoorType isSliderOutOfStock={isSliderOutOfStock} />
            <SelectWidth width={width} setWidth={setWidth} />
            <SelectHeight height={height} setHeight={setHeight} />
            <SelectDepth depth={depth} setDepth={setDepth} />
            <div className={sizeStyles.leads} onClick={goToLeads}>
              <div className={sizeStyles.text1}>💡 没找到想要的尺寸？</div>
              <div className={sizeStyles.text2}>
                <div>
                  咨询宜家定制衣柜服务
                </div>
                <div>
                  <img className={sizeStyles.leadsArrow} src={BlueRightArrow} alt="" />
                </div>
              </div>
            </div>
            <SelectColor
              frameColor={frameColor}
              setFrameColor={setFrameColor}
              width={width}
              height={height}
              depth={depth}
            />
          </div>
        </div>
      </React.Fragment>
      {showToBottomBtn &&
        <img className={sizeStyles.downTipArrow} src={DownTipArrow} alt="img"/>
      }
      {isShowToast && (
        <TopToast
          desc="请浏览完全部再进行下一步"
          onClose={() => setIsShowToast(false)}
        ></TopToast>
      )}
      <div className={styles.Footer}>
        <BottomBar
          ref={bottomBarRef}
          nextStepFn={!hasToBottom ? clickNextBtn : null}
        />
      </div>
      {showResetTips && <ResetTipsModal
        show={showResetTips}
        onClose={() => {
          setShowResetTips(false)
          localStorage.removeItem('showResetTips')
        }}
      />}
    </div>
  );
}

export default SizeFilter;
